var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import palette from './palette';
import typography from './typography';
import BadgeOverrides from '../Badge/overrides';
import ButtonOverrides from '../Button/overrides';
import ButtonGroupOverrides from '../ButtonGroup/overrides';
import CheckboxOverrides from '../Checkbox/overrides';
import ChipOverrides from '../Chip/overrides';
import DataGridOverrides from '../DataGrid/overrides';
import IconButtonOverrides from '../IconButton/overrides';
import RadioOverrides from '../Radio/overrides';
import SwitchOverrides from '../Switch/overrides';
import ToggleButtonOverrides from '../ToggleButton/overrides';
import TreeItemOverrides from '../TreeItem/overrides';
import AlertOverrides from '../Alert/overrides';
import PaginationOverrides from '../Pagination/overrides';
import TableOverrides from '../Table/primaryHeader.overrides';
import TabsOverrides from '../Tabs/overrides';
var tebraThemeValues = {
    palette: palette,
    typography: typography,
};
export default __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, BadgeOverrides(tebraThemeValues)), ButtonOverrides(tebraThemeValues)), ButtonGroupOverrides(tebraThemeValues)), CheckboxOverrides(tebraThemeValues)), ChipOverrides(tebraThemeValues)), DataGridOverrides(tebraThemeValues)), IconButtonOverrides(tebraThemeValues)), RadioOverrides(tebraThemeValues)), SwitchOverrides(tebraThemeValues)), ToggleButtonOverrides(tebraThemeValues)), TreeItemOverrides(tebraThemeValues)), AlertOverrides(tebraThemeValues)), PaginationOverrides(tebraThemeValues)), TableOverrides(tebraThemeValues)), TabsOverrides(tebraThemeValues)), { MuiFormControl: {
        marginNormal: {
            margin: '.5rem',
        },
    }, MuiInputBase: {
        root: {
            backgroundColor: palette.common.white,
        },
    } });
